import { render } from "./chat.vue?vue&type=template&id=31d5599c"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=31d5599c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31d5599c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31d5599c', __exports__)) {
    api.reload('31d5599c', __exports__)
  }
  
  module.hot.accept("./chat.vue?vue&type=template&id=31d5599c", () => {
    api.rerender('31d5599c', render)
  })

}


export default __exports__